import { Image } from "react-bootstrap";
import { CardWrapper } from "./element";
import Card from "react-bootstrap/Card";

function DocumentationCard({ item }) {
  const url = item.link;
  const domain = new URL(url).hostname;

  return (
    <CardWrapper>
      <Card>
        <Image src={item.image} className="card-img" />
        <Card.Body>
          {/* <Card.Title>{item.title}</Card.Title> */}
          <div className="link-div">
            <a href={item.link} target="_blacnk">
              {domain}
            </a>
          </div>
        </Card.Body>
      </Card>
    </CardWrapper>
  );
}

export default DocumentationCard;
